import type { ModalElementContextValue } from 'contexts/ModalProvider'
import { ModalElementContext } from 'contexts/ModalProvider'
import type { Context } from 'react'
import { useContext } from 'react'

function useModalElementContext<R = never>() {
  const modalElementContext = useContext<ModalElementContextValue<R>>(ModalElementContext as Context<ModalElementContextValue<R>>)
  return modalElementContext
}

export default useModalElementContext
